import { isArray, keyBy } from 'lodash';
import {
	colorToPercent,
	getIndicatorOrConstraintScore,
	getIndividualRiskScore
} from './ranking';

export const getItemAlteredByScenario = (item, scenario) => {
	if (!scenario?.id) return item?.o || item;

	let originalItem = item?.o || item;

	if (!originalItem) return null;

	// Si l'élément a des scénarios
	if (originalItem.scenarios && Array.isArray(originalItem.scenarios)) {
		const scenarioData = originalItem.scenarios.find(
			(s) => s.scenarioId === scenario.id
		);

		if (scenarioData) {
			return {
				...originalItem,
				x:
					scenarioData.x !== undefined
						? scenarioData.x
						: originalItem.x,
				y:
					scenarioData.y !== undefined
						? scenarioData.y
						: originalItem.y,
				trend:
					scenarioData.trend !== undefined
						? scenarioData.trend
						: originalItem.trend,
				likelihood:
					scenarioData.likelihood !== undefined
						? scenarioData.likelihood
						: originalItem.likelihood,
				impact:
					scenarioData.impact !== undefined
						? scenarioData.impact
						: originalItem.impact,
				completion:
					scenarioData.completion !== undefined
						? scenarioData.completion
						: originalItem.completion,
				o: originalItem
			};
		}
	}

	// Si aucun scénario n'est trouvé, retourner l'élément original
	return originalItem;
};

export const vulnerabilityConstraints = function (constraints) {
	//console.log('-------- vulnerability', items);

	if (!constraints || constraints.length == 0) {
		return null;
	}

	var total_weight = 0;
	var total = 0;

	for (var i = 0; i < constraints.length; i++) {
		if (constraints[i].weight !== 0)
			total_weight += constraints[i].weight || 1;

		if (constraints[i].weight !== 0)
			total +=
				colorToPercent(constraints[i].trend) *
				(constraints[i].weight || 1);
	}

	let currentPercentage = total_weight != 0 ? total / total_weight : 50;

	return currentPercentage;
};

export const vulnerabilityIndicators = function (indicators) {
	//console.log('-------- vulnerability', indicators)

	if (!indicators || indicators.length == 0) {
		return null;
	}

	var total_weight = 0;
	var total = 0;

	for (var i = 0; i < indicators.length; i++) {
		if (indicators[i].weight !== 0)
			total_weight += parseInt(indicators[i].weight) || 1;

		if (indicators[i].weight !== 0)
			total +=
				colorToPercent(indicators[i].trend) *
				(indicators[i].weight || 1);
	}

	let currentPercentage = total_weight != 0 ? total / total_weight : 50;

	return currentPercentage;
};

export const isItemInactive = (item) => {
	if (!item) return false;

	const distanceFromCenter = Math.sqrt(
		Math.pow(item.x, 2) + Math.pow(item.y, 2)
	);
	const isOutside = distanceFromCenter > 100;

	return isOutside;
};

export const isItemNeutral = (item) => {
	if (!item) return false;

	if (item.y <= 5 && item.y >= -5) return true;

	return false;
};

export const isRiskOrOpportunityWorse = (risk) => {
	if (!risk) return false;
	if (!risk.o) return false;

	return risk.isOpportunity
		? getIndividualRiskScore(risk) < getIndividualRiskScore(risk.o)
		: getIndividualRiskScore(risk) > getIndividualRiskScore(risk.o);
};

export const isRiskOrOpportunityBetter = (risk) => {
	if (!risk) return false;
	if (!risk.o) return false;

	return risk.isOpportunity
		? getIndividualRiskScore(risk) > getIndividualRiskScore(risk.o)
		: getIndividualRiskScore(risk) < getIndividualRiskScore(risk.o);
};

export const isRiskOrOpportunityFieldBetter = (risk, field) => {
	if (!risk) return false;
	if (!risk.o) return false;

	return risk.isOpportunity
		? risk[field] > risk.o[field]
		: risk[field] < risk.o[field];
};

export const isRiskOrOpportunityFieldWorse = (risk, field) => {
	if (!risk) return false;
	if (!risk.o) return false;

	return risk.isOpportunity
		? risk[field] < risk.o[field]
		: risk[field] > risk.o[field];
};

export const isRiskOrOpportunityImpactBetter = (risk) => {
	return isRiskOrOpportunityFieldBetter(risk, 'impact');
};

export const isRiskOrOpportunityImpactWorse = (risk) => {
	return isRiskOrOpportunityFieldWorse(risk, 'impact');
};

export const isRiskOrOpportunityLikelihoodBetter = (risk) => {
	return isRiskOrOpportunityFieldBetter(risk, 'likelihood');
};

export const isRiskOrOpportunityLikelihoodWorse = (risk) => {
	return isRiskOrOpportunityFieldWorse(risk, 'likelihood');
};

export const isIndicatorOrConstraintWorse = (element) => {
	if (!element) return false;
	if (!element.o) return false;

	return (
		getIndicatorOrConstraintScore([element]) <
		getIndicatorOrConstraintScore([element.o])
	);
};

export const isIndicatorOrConstraintBetter = (element) => {
	if (!element) return false;
	if (!element.o) return false;

	return (
		getIndicatorOrConstraintScore([element]) >
		getIndicatorOrConstraintScore([element.o])
	);
};
